module.exports = __webpack_public_path__ + "img/login_img.9049c6b6.png";